/**
 * E-Mail-Vorlagen im Profil-Tab Kommunikation ("+ Vorlage", Batch F2).
 *
 * Eigene Datei — NICHT `src/lib/api.ts` (dort arbeiten parallel andere
 * Agenten an anderen Batch-13-Paketen, siehe Freigabeliste). Importiert die
 * apiV2-Instanz sowie den bereits dort definierten `EmailTemplate`-Typ und
 * `emailTemplatesApi` (Liste) statt sie zu duplizieren.
 *
 * Backend-Vertrag (additiv zu den bestehenden `/v2/admin/email-templates*`-
 * Routen aus api.ts):
 *
 *   GET  /v2/admin/email-templates/{id}/preview?user_id=
 *        → { type, subject, html } — Vorschau für einen konkreten Empfänger
 *          (Variablen aus User/Profil ersetzt), KEIN Versand.
 *
 *   POST /v2/admin/email-templates/{id}/send { user_id, variables? }
 *        → { type, message, result } — Empfänger = users.email, Variablen
 *          automatisch aus User/Profil befüllt (dieselbe Quelle wie der
 *          automatisierte Stage-Versand, PhaseActionService::variablesFor()).
 *          Schreibt zusätzlich eine `messages`-Zeile (v1-Tabelle), damit der
 *          Versand im Kommunikation-Tab (liest v1 GET /admin/user/{id}/messages)
 *          erscheint.
 */
import { apiV2, emailTemplatesApi } from './api';
import type { EmailTemplate, EmailTemplateSendResult } from './api';

export type { EmailTemplate, EmailTemplateSendResult };

export interface EmailTemplatePreview {
  subject: string;
  html: string;
}

export const emailTemplatesForUser = {
  /** GET /v2/admin/email-templates → alle Vorlagen (für die Auswahlliste im Modal). */
  list: emailTemplatesApi.list,

  /**
   * GET /v2/admin/email-templates/{id}/preview?user_id= — Betreff + HTML mit
   * für DIESEN Empfänger ersetzten Variablen. Reine Vorschau, kein Versand.
   */
  previewForUser: async (templateId: number, userId: number): Promise<EmailTemplatePreview> => {
    const res = await apiV2.get<{ type: string; subject?: string; html?: string }>(
      `/admin/email-templates/${templateId}/preview`,
      { params: { user_id: userId } },
    );
    return { subject: res.data.subject ?? '', html: res.data.html ?? '' };
  },

  /**
   * POST /v2/admin/email-templates/{id}/send { user_id } — Versand an
   * users.email des angegebenen Users, Variablen automatisch aus User/Profil.
   */
  sendToUser: async (
    templateId: number,
    userId: number,
    variables?: Record<string, string>,
  ): Promise<EmailTemplateSendResult> => {
    const res = await apiV2.post<{ type: string; message: string; result?: EmailTemplateSendResult }>(
      `/admin/email-templates/${templateId}/send`,
      { user_id: userId, variables },
    );
    return res.data.result ?? { ok: true, message: res.data.message };
  },
};
